class FormService {
	getPlaceholders(themeManager, formType) {
		const getThemeKey = (field) => {
			const key =  formType + 'Placeholder' + field;
			if (themeManager.getThemeTextOrHardcodedDefault(key)) {
				return key;
			}
			return 'placeholder' + field;
		};

		return {
			salutation: themeManager.getThemeTextOrHardcodedDefault(getThemeKey('Salutation')),
			customSalutation: themeManager.getThemeTextOrHardcodedDefault(getThemeKey('CustomSalutation')),
			companyName: themeManager.getThemeTextOrHardcodedDefault(getThemeKey('CompanyName')),
			firstname: themeManager.getThemeTextOrHardcodedDefault(getThemeKey('Firstname')),
			lastname: themeManager.getThemeTextOrHardcodedDefault(getThemeKey('Lastname')),
			phoneNumber: themeManager.getThemeTextOrHardcodedDefault(getThemeKey('PhoneNumber')),
			email: themeManager.getThemeTextOrHardcodedDefault(getThemeKey('Email')),
			street: themeManager.getThemeTextOrHardcodedDefault(getThemeKey('Street')),
			houseNumber: themeManager.getThemeTextOrHardcodedDefault(getThemeKey('HouseNumber')),
			postalCode: themeManager.getThemeTextOrHardcodedDefault(getThemeKey('PostalCode')),
			city: themeManager.getThemeTextOrHardcodedDefault(getThemeKey('City')),
			country: themeManager.getThemeTextOrHardcodedDefault(getThemeKey('Country')),
		};
	}

	formatSpecificFieldValues(name, value) {
		let handledValue = value;
		// strip whitespaces from email-address string
		if (name === 'email') {
			handledValue = value.replace(/\s+/g, '');
		}
		return handledValue;
	}

	removeWhiteSpaces(value) {
		return value.replace(/\s+/g, '');
	}

	findAddressErrorForField(errors, field, fieldName) {
		if (errors && errors.length > 0) {
			let errorsResult = []
			let errorsFound = errors.filter(error => error.includes(field))
			if (errorsFound.length > 0) {
				errorsFound.map(error => {
					const errorType = this.getErrorTypeForAddressField(error)
					errorsResult.push({
						error: error,
						message: this.getErrorMessageForAddressField(errorType, fieldName, field)
					});
				})
				return errorsResult
			}
		}
		return null
	}

	getErrorTypeForAddressField(error) {
		const errorType = error.split(/_(.*)/)[1]
		return errorType ? errorType : 'generic'
	}

	getErrorMessageForAddressField(errorType, fieldName, field) {
		let message = 'Das Feld ' + fieldName + ' ist invalid.'
		if (errorType === 'required') {
			message = 'Das Feld ' + fieldName + ' ist Pflichtfeld.'
		} else if (errorType === 'format' && fieldName === 'Email') {
			message = 'Bitte korrigieren Sie das Format der E-Mail-Adresse.'
		} else if (errorType === 'invalid' && field === 'comment') {
			message = 'Das Feld ' + fieldName + ' enthält ungültige Zeichen.'
		}
		return message

	}
}

const formService = new FormService();
export default formService;
